<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차서비스</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차서비스</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">정기권</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권">정기권</router-link></li>
            <li><router-link to="/webdiscountcharge" title="웹 선불권">웹 선불권</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">정기권 조회/결제</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권 안내">정기권 안내</router-link></li>
            <li><router-link to="/periodapplication" title="정기권 신청">정기권 신청</router-link></li>
            <!-- <li><router-link to="/periodlookup" title="정기권 조회/결제">정기권 조회/결제</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">정기권 결제</h3>
        <article>
          <!--table pc-->
          <div class="table horizontal-table web">
            <table>
              <caption>
                정기권 결제 테이블
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">이름</th>
                  <td colspan="3">{{ periodInfo.waitingNm }}</td>
                </tr>
                <tr>
                  <th scope="row">주소</th>
                  <td colspan="3">{{ periodInfo.addr }}</td>
                </tr>
                <tr>
                  <th scope="row">연락처</th>
                  <td colspan="3">{{ periodInfo.mobile }}</td>
                </tr>
                <tr>
                  <th scope="row">신청 주차장</th>
                  <td>[{{ periodInfo.parkingDivCdNm }}] {{ periodInfo.parkingNm }}</td>
                  <th scope="row">주차구분</th>
                  <td>{{ periodInfo.useDivCd.name }}</td>
                </tr>
                <tr>
                  <th scope="row">차량번호</th>
                  <td>
                    <strong class="colorType blue">{{ periodInfo.carNo }}</strong>
                  </td>
                  <th scope="row">차량 소유주명</th>
                  <td>{{ periodInfo.carOwnerNm }}</td>
                </tr>
                <tr>
                  <th scope="row">할인자격</th>
                  <td>{{ periodPayment.discountCd.discountNm }}</td>
                  <th scope="row">이용기간</th>
                  <td v-if="periodInfo.useStartDt !== '' && periodInfo.useEndDt !== ''">
                    {{ periodInfo.useStartDt | ptDateFormat }} ~ {{ periodInfo.useEndDt | ptDateFormat }}
                  </td>
                  <td v-else>이용기간이 존재하지 않습니다. 관리자에게 문의해주세요.</td>
                </tr>
                <tr>
                  <th scope="row">월 정기권금액</th>
                  <td colspan="3">
                    <strong class="colorType blue">{{ periodInfo.useAmt | comma }}원</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table pc-->

          <!--table mobile-->
          <div class="table horizontal-table mobile">
            <table>
              <caption>
                정기권 결제 테이블
              </caption>
              <colgroup>
                <col style="width: 35%" />
                <col style="width: 65%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">이름</th>
                  <td>{{ periodInfo.waitingNm }}</td>
                </tr>
                <tr>
                  <th scope="row">주소</th>
                  <td>{{ periodInfo.addr }}</td>
                </tr>
                <tr>
                  <th scope="row">연락처</th>
                  <td>{{ periodInfo.mobile }}</td>
                </tr>
                <tr>
                  <th scope="row">신청 주차장</th>
                  <td>[{{ periodInfo.parkingDivCdNm }}] {{ periodInfo.parkingNm }}</td>
                </tr>
                <tr>
                  <th scope="row">주차구분</th>
                  <td>{{ periodInfo.useDivCd.name }}</td>
                </tr>
                <tr>
                  <th scope="row">차량번호</th>
                  <td>
                    <strong class="colorType blue">{{ periodInfo.carNo }}</strong>
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량 소유주명</th>
                  <td>{{ periodInfo.carOwnerNm }}</td>
                </tr>
                <tr>
                  <th scope="row">할인자격</th>
                  <td>{{ periodPayment.discountCd.discountNm }}</td>
                </tr>
                <tr>
                  <th scope="row">이용기간</th>
                  <td v-if="periodInfo.useStartDt !== '' && periodInfo.useEndDt !== ''">
                    {{ periodInfo.useStartDt }} ~ {{ periodInfo.useEndDt }}
                  </td>
                  <td v-else>이용기간이 존재하지 않습니다. 관리자에게 문의해주세요.</td>
                </tr>
                <tr>
                  <th scope="row">월 정기권금액</th>
                  <td>
                    <strong class="colorType blue">{{ periodInfo.useAmt | comma }}원</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table mobile-->
        </article>
        <article class="btnArea">
          <button
            type="button"
            v-if="
              periodPayment.procStsCd.id === 'MUT-004' ||
              periodPayment.procStsCd.id === 'MUT-005' ||
              periodPayment.procStsCd.id === 'MUT-006'
            "
            class="btn gray"
            @click="$router.push('/periodlookup')"
          >
            취소
          </button>
          <button
            type="button"
            v-else-if="periodPayment.procStsCd.id === 'MUT-002'"
            class="btn gray"
            @click="$router.push('/periodlookup')"
          >
            목록
          </button>
          <button
            type="button"
            v-if="
              periodPayment.procStsCd.id === 'MUT-004' ||
              periodPayment.procStsCd.id === 'MUT-005' ||
              periodPayment.procStsCd.id === 'MUT-006'
            "
            class="btn blue"
            @click="paymentBtn()"
          >
            결제
          </button>
          <button type="button" v-else-if="periodPayment.procStsCd.id === 'MUT-002'" class="btn blue disabled">
            결제완료
          </button>
        </article>
      </div>
    </section>

    <!-- 스마트로 결제 폼 -->
    <form id="tranMgr" name="tranMgr" method="post">
      <input type="hidden" name="PayMethod" v-model="smartropayParms.PayMethod" />
      <input type="hidden" name="GoodsCnt" v-model="smartropayParms.GoodsCnt" />
      <input type="hidden" name="GoodsName" v-model="smartropayParms.goodsName" />
      <input type="hidden" name="Amt" v-model="smartropayParms.amount" />
      <input type="hidden" name="Moid" v-model="smartropayParms.moid" />
      <input type="hidden" name="Mid" v-model="smartropayParms.mid" />
      <input type="hidden" name="ReturnUrl" v-model="smartropayParms.returnUrl" />
      <input type="hidden" name="BuyerName" v-model="smartropayParms.buyerName" />
      <input type="hidden" name="BuyerTel" v-model="smartropayParms.buyerTel" />
      <input type="hidden" name="BuyerEmail" v-model="smartropayParms.BuyerEmail" />
      <input type="hidden" name="MallIp" v-model="smartropayParms.MallIp" />
      <input type="hidden" name="EncryptData" v-model="smartropayParms.encryptData" />
      <input type="hidden" name="EdiDate" v-model="smartropayParms.ediDate" />
      <input type="hidden" name="TaxAmt" v-model="smartropayParms.TaxAmt" />
      <input type="hidden" name="TaxFreeAmt" v-model="smartropayParms.TaxFreeAmt" />
      <input type="hidden" name="VatAmt" v-model="smartropayParms.VatAmt" />
    </form>

    <form id="approvalForm" name="approvalForm" method="post">
      <input type="hidden" id="Tid" name="Tid" />
      <input type="hidden" id="TrAuthKey" name="TrAuthKey" />
    </form>
    <!-- 스마트로 결제 폼 -->
  </main>
</template>

<script>
import axios from '../../../util/axios';

export default {
  data() {
    return {
      carNo: '',
      periodId: '',
      periodInfo: {},
      periodPayment: {
        extraCd: '',
        useDivCd: '',
        procStsCd: '',
        discountCd: '',
      },
      paymentInfo: {},
      smartropayParms: {},
    };
  },

  mounted() {
    const data = this.$route.params.data;
    const sttus = this.$route.query.r;
    if (sttus) {
      alert('결제가 정상적으로 처리되었습니다.');
      this.$router.push('/periodlookup');
      return;
    }
    if(!data) {
      alert('잘못된 접근입니다.');
      this.$router.push('/periodlookup')
    }
    this.carNo = data.carNo;
    this.periodId = data.periodId;
    this.findPeriod();
  },

  methods: {
    async findPeriod() {
      const apiParams = new FormData();
      apiParams.append('periodId', this.periodId);
      apiParams.append('isMobile', this.$isMobile());
      const res = await axios('get', '/api/period/view.json', Object.fromEntries(apiParams));
      const resData = res.data;
      if(resData.resultMap.result.expiredYn == 'N') {
        alert('정기권 납부 기한이 마감되었습니다.')
        this.$router.push('/periodlookup')
        return;
      }
      this.periodInfo = resData.resultMap.result;
      this.periodPayment.discountCd = resData.resultMap.result.discountCd;
      this.periodPayment.extraCd = resData.resultMap.result.extraCd;
      this.periodPayment.useDivCd = resData.resultMap.result.useDivCd;
      this.periodPayment.procStsCd = resData.resultMap.result.procStsCd;
      this.paymentInfo = resData.resultMap.easypayParams;
    },

    async paymentBtn() {
      let apiParams = new FormData();
      apiParams.append('amount', this.paymentInfo.amount);
      apiParams.append('inOutId', this.inOutId);
      apiParams.append('payCategory', 'COMMUTATION_TICKET');
      apiParams.append('isStatus', false);
      apiParams.append('memberInfoId', this.$store.state.empNo);
      apiParams.append('carNumber', this.carNo);
      apiParams.append('period', this.paymentInfo.value3);
      const res = await axios('post', '/api/smartropay/payment', apiParams);
      const { ediDate = '', encryptData = '', mid = '', amount = '', paymentId = '' } = res.data.result;
      const RETURN_URL = `${process.env.VUE_APP_DOMAIN}/api/smartropay/callApproval/periodview/${paymentId}`;

      const TaxFreeAmt = 0;
      const tmp = amount / 1.1;
      const VatAmt = Math.floor(amount - tmp);
      const TaxAmt = amount - VatAmt;

      const buyerName = this.$store.state.empNm ? this.$store.state.empNm : this.carNo;
      const buyerTel = this.$store.state.empMobile ? this.$store.state.empMobile : '01000000000';

      this.smartropayParms = {
        goodsName: this.paymentInfo.goodsName,
        amount: amount,
        moid: paymentId,
        mid: mid,
        returnUrl: RETURN_URL,
        StopUrl: RETURN_URL,
        buyerName: buyerName,
        buyerTel: buyerTel,
        encryptData: encryptData,
        ediDate: ediDate,
        TaxAmt: TaxAmt,
        VatAmt: VatAmt,
        TaxFreeAmt: TaxFreeAmt,
        PayMethod: 'CARD',
        GoodsCnt: 1,
        BuyerEmail: 'noname@smartro.co.kr',
        MallIp: '211.57.44.13',
      };

      await smartropay.init({
        mode: process.env.VUE_APP_SMARTRO_INIT,
      });

      await smartropay.payment({
        FormId: 'tranMgr',
        Callback: function (res) {
          var approvalForm = document.approvalForm;
          approvalForm.Tid.value = res.Tid;
          approvalForm.TrAuthKey.value = res.TrAuthKey;
          approvalForm.action = RETURN_URL;
          approvalForm.submit();
        },
      });
    },
  },
};
</script>
